import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Parser from "html-react-parser";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import timelineStyle from "assets/jss/material-dashboard-pro-react/components/timelineStyle.jsx";
import moment from "moment";
import {Clear, DoneAll, HourglassEmptyOutlined, Send} from "@material-ui/icons";

function Timeline({...props}) {

  const {classes, stories, simple, standalone} = props;
  const timelineClass = classes.timeline + " " + cx({[classes.timelineSimple]: simple, [classes.timelineStandalone]: standalone,});
  return (
    <ul className={timelineClass}>
      {stories.map((prop, key) => {
        let icone = {
          submetido: <HourglassEmptyOutlined/>,
          submetido_validado: <Send/>,
          aprovado: <DoneAll/>,
          rejeitado: <Clear/>,
          reaberto: <Clear/>
        }[prop.estado]

        let cor = {
          submetido: "info",
          submetido_validado: "info",
          aprovado: "primary",
          rejeitado: "warning",
          reaberto: "danger"
        }[prop.estado]

        const panelClasses = classes.timelinePanel + " " + cx({[classes.timelinePanelInverted]: prop.inverted, [classes.timelineSimplePanel]: simple});
        const timelineBadgeClasses = classes.timelineBadge + " " + classes[cor] + " " + cx({[classes.timelineSimpleBadge]: simple});

        return (
          <li className={classes.item} key={key}>
            {icone ? (
              <div className={timelineBadgeClasses}>
                {icone}
              </div>
            ) : null}
            <div className={panelClasses}>
              {(prop.designacao) ? (
                <div className={classes.timelineHeading} style={!prop.observacao ? {marginBottom: '-15px'} : null}>
                  {!!prop.designacao && <div className={classes.timelineHeading}>
                    {prop.designacao}
                    <p>{moment(prop.data_alteracao).format("DD/MM/YYYY [às] H:mm")}</p>
                  </div>}
                </div>
              ) : null}
              {prop.observacao ? <div className={classes.timelineBody}>{Parser(prop.observacao?.split("\n").join("<br>"))}</div> : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

Timeline.propTypes = {
  classes: PropTypes.object.isRequired,
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  simple: PropTypes.bool,
  standalone: PropTypes.bool
};

export default withStyles(timelineStyle)(Timeline);
